import React from 'react';

import Home from 'components/Home';

const HomeAbaca = () => <Home isAdmin={true} />

export default HomeAbaca;